import { getEnv } from "src/utils/EnvironmentTools";
import { ImageInfo, SignedUrlResponse, } from "src/utils/upload-image/model/upload-image.model";
import { createGetSignedUrlBody, getUploadHeaders, UploadImageErrorTypes, } from "src/utils/upload-image/UploadImageTools";
import { computeMd5Base64 } from "src/utils/observability/logs/image-integrity/imageIntegrityLogs";
import { FetchOptions } from "../api.models";
import { trackUploadSignedUrlRetry } from "src/utils/observability/metrics/product-upload/counters/productUploadCounters";

class AmandaApi {
  async signedURL<T>(imageInfo: ImageInfo): Promise<SignedUrlResponse> {
    const body = await createGetSignedUrlBody(imageInfo);
  
    const options: FetchOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
  
    const url = getEnv().amandaBaseUrl + "/v2/signedUrl";
  
    try {
      const response = await fetch(url, options);
      return await response.json();
    } catch (error) {
      return await Promise.reject(new Error(UploadImageErrorTypes.Signing));
    }
  }
  
  async uploadSignedURL<T>( imageInfo: ImageInfo, signedUrlResponse: SignedUrlResponse, ): Promise<{ assetId: string }> {
    const { url, assetId } = signedUrlResponse;
    const { file } = imageInfo;
    const headers = getUploadHeaders(imageInfo, signedUrlResponse);

    const md5Base64 = await computeMd5Base64(file);
    headers['Content-MD5'] = md5Base64;

    const options: FetchOptions = {
      method: "PUT",
      headers,
      body: file,
    };

    const MAX_RETRIES = 3;
    let lastResponse: Response | undefined;

    for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
      if (attempt > 0) {
        trackUploadSignedUrlRetry({ attempt: String(attempt) });
      }
      try {
        const response = await fetch(url, options);

        if (response?.status === 400) {
          lastResponse = response;
        } else {
          return { assetId };
        }
      } catch (error) {
        if (attempt === MAX_RETRIES - 1) {
          return await Promise.reject(new Error(UploadImageErrorTypes.Uploading));
        }
      }
    }

    return await Promise.reject(new Error(UploadImageErrorTypes.Uploading));
  }
}

export default AmandaApi;